import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "block pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "colums is-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "columnis-10 is-offset-1" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "has-text-centered has-text-primary is-size-5 p-5",
      style: {"font-family":"Calibri"}
    }, " Nosotros brindamos asesoramiento especializado y tecnología de vanguardia en maquinaria para mejorar la eficiencia, calidad y seguridad de su empresa, maximizando su rentabilidad. ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("figure", { class: "image is-16by9" }, [
  /*#__PURE__*/_createElementVNode("video", {
    autoplay: "",
    loop: "",
    muted: "",
    class: "has-ratio",
    frameborder: "0",
    width: "100%",
    height: "auto"
  }, [
    /*#__PURE__*/_createElementVNode("source", {
      src: "/video_inicio_alfapack.mp4",
      type: "video/mp4"
    })
  ])
], -1)
const _hoisted_5 = { class: "container pb-6" }
const _hoisted_6 = { class: "block pt-6" }
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "column is-8 is-offset-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "colums is-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-10 is-offset-1" }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "has-text-centered has-text-primary has-text-weight-bold",
      style: {"font-family":"Calibri"}
    }, [
      /*#__PURE__*/_createTextVNode(" En el momento que lo necesites, "),
      /*#__PURE__*/_createElementVNode("span", { class: "has-text-yellow" }, "contáctanos.")
    ])
  ])
], -1)
const _hoisted_10 = { class: "block pt-5" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = { class: "has-text-centered pt-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered pt-2",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Integramos maquinaria en diversas líneas de producción. ", -1)
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "has-text-centered pt-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered pt-2",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Realizamos servicios de mantenimiento o reparación. ", -1)
const _hoisted_17 = { class: "column" }
const _hoisted_18 = { class: "has-text-centered pt-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  class: "has-text-primary has-text-centered pt-2",
  style: {"font-family":"Calibri","font-weight":"bold"}
}, " Ofrecemos refacciones para mantener tus equipos en óptimas condiciones. ", -1)
const _hoisted_20 = { class: "container" }
const _hoisted_21 = { class: "hero has-background-blue pt-6 pb-6" }
const _hoisted_22 = { class: "hero-body" }
const _hoisted_23 = { class: "container" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"columns is-centered is-mobile\"><div class=\"column is-two-thirds\"><p class=\"has-text-white has-text-centered is-size-6 pt-4 pb-6\" style=\"font-family:Calibri;font-weight:bold;\"> Valoramos la durabilidad en las relaciones. Creemos en la confianza, la lealtad y el compromiso como pilares clave. Nuestra filosofía se refleja en cada proyecto, marcando la diferencia en el mercado y más allá. </p></div></div><div class=\"is-mobile level\"><div class=\"level-item\"><button class=\"button is-hoverable has-background-yellow has-text-white is-normal\" style=\"font-family:Calibri;font-weight:bold;border:none;width:15rem;height:3rem;\"> CONTACTA A UN ASESOR </button></div></div>", 2)

import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import EquiposCarrusel from "@/components/EquiposCarrusel.vue";
import DifferenceComponent from "@/components/DifferenceComponent.vue";
import { mdiCog, mdiHandExtended, mdiWrench } from "@mdi/js";
import { useWindowSize } from "vue-window-size";
import RepresentadasComponent from "@/components/RepresentadasComponent.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { width } = useWindowSize();

const videoInicio = ref({ src: require("@/assets/video_inicio_alfapack.mp4") });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ContactBar),
      _createVNode(NavigationBar),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
          style: {"font-family":"Calibri","font-weight":"bold"}
        }, " ALFA PACK, HACEMOS LA DIFERENCIA ", 2),
        _hoisted_3
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h1", {
              class: _normalizeClass(["has-text-centered has-text-primary", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
              style: {"font-family":"Calibri","font-weight":"bold"}
            }, " ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE ", 2)
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["columns is-variable", _unref(width) < 768 ? '' : 'is-7'])
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-5",
                  type: "mdi",
                  path: _unref(mdiCog),
                  style: {"color":"white","background-color":"#38ac61","width":"7.5rem","height":"7.5rem","border-radius":"50%"}
                }, null, 8, ["path"])
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", _hoisted_15, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-5",
                  type: "mdi",
                  path: _unref(mdiHandExtended),
                  style: {"color":"white","background-color":"#38ac61","width":"7.5rem","height":"7.5rem","border-radius":"50%"}
                }, null, 8, ["path"])
              ]),
              _hoisted_16
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", _hoisted_18, [
                _createVNode(_unref(SvgIcon), {
                  class: "p-5",
                  type: "mdi",
                  path: _unref(mdiWrench),
                  style: {"color":"white","background-color":"#38ac61","width":"7.5rem","height":"7.5rem","border-radius":"50%"}
                }, null, 8, ["path"])
              ]),
              _hoisted_19
            ])
          ], 2)
        ])
      ])
    ]),
    _createVNode(RepresentadasComponent, { "has-title": true }),
    _createVNode(DifferenceComponent),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(EquiposCarrusel, {
        clasification: "todos",
        title: "TE INVITAMOS A CONOCER NUESTROS EQUIPOS",
        text: "Ofrecemos una amplia gama de equipos para múltiples industrias: alimentos, bebidas, farmacéutica y más, cubriendo necesidades de envase, empaque y embalaje."
      })
    ]),
    _createElementVNode("section", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h1", {
            class: _normalizeClass(["has-text-centered has-text-white", _unref(width) < 768 ? 'is-size-3' : 'is-size-1']),
            style: {"font-family":"Calibri","font-weight":"bold"}
          }, " PONTE EN CONTACTO CON NOSOTROS ", 2),
          _hoisted_24
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})